import React from 'react';
import { MessageSquare, FileText, AlignLeft } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Секция с содержимым письма
 */
const BodyContentSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  loadTemplate,
  emailTemplates 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4 flex items-center">
        <MessageSquare className="w-5 h-5 mr-2 text-indigo-500" />
        Содержимое письма
      </h3>

      <div className="mb-4">
        <label htmlFor="body" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <AlignLeft className="w-4 h-4 mr-2 text-indigo-500" />
          Текст письма
        </label>
        <textarea
          id="body"
          name="body"
          value={formData.body}
          onChange={handleInputChange}
          rows={6}
          placeholder="Введите текст письма..."
          className={`form-textarea w-full ${errors.body ? 'input-error' : ''}`}
        />
        {errors.body && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.body}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Используйте символ \n для добавления переноса строки
        </p>
      </div>

      {/* Быстрые шаблоны писем */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
          <FileText className="w-4 h-4 mr-2 text-indigo-500" />
          Шаблоны писем
        </label>
        <div className="flex flex-wrap gap-2">
          {emailTemplates.map((template) => (
            <Button
              key={template.id}
              type="button"
              variant="outline"
              size="sm"
              onClick={() => loadTemplate(template.id)}
            >
              {template.name}
            </Button>
          ))}
        </div>
      </div>

      {/* Настройки форматирования */}
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              name="addLineBreaks"
              checked={formData.addLineBreaks}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Автоматически добавлять переносы строк
            </span>
          </label>
        </div>
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              name="useCyrillicEncoding"
              checked={formData.useCyrillicEncoding}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Корректное отображение русских букв
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default BodyContentSection;